import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {field} from "../../stem-core/state/StoreField";
import {apiClient} from "../connection/BlinkApiClient";
import type {StoreId} from "../../stem-core/state/State";
import {UserProfile} from "./UserProfileStore";
import {Jurisdiction} from "./JurisdictionStore";
import {StemDate} from "../../stem-core/time/Date";

@globalStore
export class LegalEntity extends BaseStore("LegalEntity") {
    @field("UserProfile") owner: UserProfile;
    @field(Date) createdAt: StemDate;
    @field(String) name: string;
    @field(String) legalName: string;
    @field("Jurisdiction") jurisdiction: Jurisdiction;
    @field(String) legalEntityType: string;
    @field(Boolean) isNonprofit: boolean;
    @field(String) taxId: string;
    @field(String) streetAddress: string;
    @field(String) stateAddress: string;
    @field(String) cardStatementName: string;
    @field(String) bankAccountLastDigits: string;

    toString(): string {
        return this.name;
    }

    toUI(): string {
        return this.toString();
    }
}

// UpdateLegalEntityRequest (api/admin_api/views/legal_entities.py). Not merchant-scoped: a legal entity
// belongs to an owner, not a merchant
export interface UpdateLegalEntityRequest {
    legalEntityId: StoreId;
    ownerId?: StoreId;
    name?: string;
    legalName?: string;
    jurisdictionId?: StoreId;
    legalEntityType?: string;
    isNonprofit?: boolean;
    taxId?: string;
    address?: string;
    cardStatementName?: string;
    bankAccountLastDigits?: string;
}

export async function apiUpdateLegalEntity(data: UpdateLegalEntityRequest): Promise<any> {
    return apiClient.post("admin/legal_entities/update", data)
}
